import store from "../../../store";
import { toTitleCase } from "../Dashboard/Charts/utils";

export const messageType = (postType) => {
    if (postType === "DM") return "Private Message";
    if (postType === "COMMENT") return "Comment";
    if (postType === "POST") return "Post";
    if (postType === "REPLY") return "Reply";
    if (postType === "TWEET") return "Tweet";
    if (postType === "NOTE") return "Note";
};
export const getPriority = (priorityVal = "") => {
    const priorities = ["low", "medium", "high"];

    const priority = priorityVal?.toLowerCase();
    return priorities.includes(priority) ? toTitleCase(priority) : toTitleCase("medium");
};

export const getPriorityLists = () => {
    const priorities = ["high", "medium", "low"];
    return priorities.map((ele) => ({ key: ele, label: toTitleCase(ele), value: ele }));
};

function replaceTextWithLink(matched) {
    let withProtocol = matched;

    // if (!withProtocol.startsWith("http")) {
    //     withProtocol = "http://" + matched;
    // }

    const newStr = `<a href=${withProtocol} target="_blank" >${matched}</a>`;

    return newStr;
}

export function getPostTextContent(ticket, message, isReceived = false) {
    //console.log("[TICKET, MESSAGE]", ticket, message);

    if (ticket.post.type === "NOTE") {
        let text = getMentionedUsernames(message);
        text = modifyEmailReply(text);
        return text;
    }

    if (ticket.platform.short_name === "facebook") {
        return getMentionedUsernames(message, "facebook");
    }

    if (ticket.platform.short_name === "twitter") {
        return getMentionedUsernames(message, "twitter"); //
    }

    if (ticket.platform.short_name === "linkedin") {
        return getMentionedUsernames(message, "linkedin");
    }
    //message =getMentionedUsernames(message)
    // if (!message) return;

    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;

    const modifiedStr = message.replace(urlRegex, replaceTextWithLink);

    return modifiedStr;
}
export const replaceMentionedUsernames = (str, mentionedObj, replyType) => {
    let reply = str;
    const mentions = [];

    if (Object.keys(mentionedObj).length === 0) {
        return { reply, mentions };
    }

    const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string

    for (const key in mentionedObj) {
        const username = mentionedObj[key];
        const escapedUsername = escapeRegExp(username);
        const mentionPattern = new RegExp(`(${escapedUsername})`, "gi");
        // output = output.replace(mentionPattern, `@[user:${key}]`);

        if (reply.match(mentionPattern)) {
            if (!mentions.find((mention) => mention.mention_id === +key)) {
                mentions.push({
                    mention_id: +key,
                    mention_type: "user",
                    mention_name: username,
                });
            }

            if (replyType === "note") reply = reply.replace(mentionPattern, `[user:${key}](${username})`);
            else reply = reply.replace(mentionPattern, `[${username}]`);
        }
    }

    return { reply, mentions };
};

export const getMentionedUsernames = (input, platform = "", pageName = "") => {
    let agentsObj = store.getState().socialResponseReducer.agentListValue || {};
    //const userListObj = store.getState().socialResponseReducer.userListObj || {};

    if (platform === "facebook") {
        const originalText = input.replace(/@\[([\s\S]*?)\]/g, (match, username) => {
            return `<span style="font-weight: bold;">@${username} </span>`;
        });
        return originalText;
    }

    if (platform === "twitter") {
        const originalText = input.replace(/@(\w+)/g, (match, username) => {
            return `<span style="font-weight: bold;">@${username} </span>`;
        });

        return originalText;
    }

    if (platform === "linkedin") {
        const mentionRegex = /\[@(.*?)]/g;
        const originalText = input.replace(mentionRegex, (match, username) => {
            const mention = match.slice(2, -1); // remove the brackets
            return `<span style="font-weight: bold;">@${mention}</span>`;
        });

        return originalText;
    }

    if (!input?.includes("@[user:")) {
        return input;
    }
    const mentionPattern = /\[user:(\d+)\](\((\w+)\))?/g;

    const originalText = input.replace(mentionPattern, (match, userId, _, name) => {
        if (name) {
            return agentsObj[userId] ? `<span style="font-weight: bold;">${agentsObj[userId]?.name}</span>` : name;
        }

        return agentsObj[userId] ? `<span style="font-weight: bold;">${agentsObj[userId]?.name}</span>` : match;
    });

    return originalText;
};

export const highlightNotifcationContent = (text) => {
    const regex = /@(\w+)/g;
    const formattedText = text?.replace(regex, '<span style="font-weight: bold;">@$1</span>');
    return formattedText;
};

export const maskEmail = (email = "") => {
    const [name, domain] = email.split("@");
    const { length: len } = name;
    const maskedName = name[0] + "*****" + name[len - 1];

    if (domain) {
        const [domain1, domain2] = domain.split(".");
        const maskedDomain = domain1[0] + "****" + ".";
        const maskedEmail = maskedName + "@" + maskedDomain + domain2;
        return maskedEmail;
    } else {
        const maskedEmail = maskedName + "@" + "****" + ".com";
        return maskedEmail;
    }
};

/**
 * @author Harshit Kr Vishwakarma
 * @description Masks one or multiple emails, if multiple emails are passed then it should be separated by comma
 * @param {string} emails single email or multiple emails separated by comma
 * @returns {string} masked email(s)
 */
export const maskMultipleEmails = (email = "") =>
    email.includes(",")
        ? email
              .split(",")
              .map((email) => maskEmail(email.trim()))
              .join(",")
        : maskEmail(email);

/**
 * @author Harshit Kr Vishwakarma
 * @description Matches if the string ends with the given pattern and modifies the string if matched
 * @param {string} text
 * @returns {string}
 */
export const modifyEmailReply = (text) => {
    const pattern = /(By: .+) \[(.+@.+)\]$/i;

    return text.replace(pattern, (match, p1, p2) => {
        const maskedEmail = maskMultipleEmails(p2);
        return `<br>${p1} (${maskedEmail})`;
    });
};
